import {
  AppBar,
  Backdrop,
  Box,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  List,
  ListItemButton,
  ListItemText,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import axiosBaseURL from "../../../utilities/httpCommon";
import Pagination from "@mui/material/Pagination";
import usePagination from "../../../utilities/Pagination";
import { addCustomXmlPart } from "../../../utilities/Wordutil";
import OfficeAddinMessageBar from "./OfficeAddinMessageBar";

/* global console Word window */

const Playbook = () => {
  const [templatedata, settemplatedata] = useState([]);
  const [orglistvalues, setorglistvalues] = useState([]);
  const [isprogress, setprogress] = useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [seltype, setSeltype] = React.useState("");
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = React.useState(1);
  const [typelist, settypelist] = useState([]);
  const [errMsgd, seterrMsgd] = useState("");
  const PER_PAGE = 60;
  const count = Math.ceil(templatedata.length / PER_PAGE);
  const _DATA = usePagination(templatedata, PER_PAGE);

  const handleSelectChange = (event: SelectChangeEvent) => {
    const filterval = event.target.value as string;
    setSeltype(filterval);
    if (filterval === "All") {
      settemplatedata(orglistvalues);
    } else {
      let filterlst = orglistvalues.filter(function (obj) {
        return obj.type === filterval;
      });
      settemplatedata(filterlst);
    }
  };

  const handleChange = (_event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
    _DATA.jump(value);
  };

  const errorDismissed = () => {
    seterrMsgd("");
  };

  const fetchData = async () => {
    try {
      setprogress(true);
      const res = await axiosBaseURL
        .get("/sfserver/getmetadata?object=Template__c", {
          withCredentials: true,
        })
        .catch((error) => {
          setprogress(false);
          if (error.response) {
            seterrMsgd(error.response.data);
          } else if (error.request) {
            seterrMsgd(error.request);
          } else {
            seterrMsgd(error.message);
          }
        });
      setprogress(false);
      if (res.data != null) {
        console.log(res.data.fields);
        res.data.fields.forEach((field) => {
          if (field.picklistValues.length > 0) {
            if (field.name == "Type__c") {
              settypelist(field.picklistValues);
              setSeltype("All");
            }
          }
        });
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  async function OpenSelectedTemplate() {
    if (selectedIndex >= 0) {
      setprogress(true);
      let selId = templatedata[selectedIndex].id;
      let result = await QueryData(
        "SELECT Id, LinkedEntityId, ContentDocumentId FROM ContentDocumentLink where LinkedEntityId='" + selId + "'",
        false
      );
      if (result != null) {
        console.log(result);
        let docId = result[0].ContentDocumentId;
        let doccontent = await QueryData(
          "SELECT Id, Title, ContentDocumentId, VersionData FROM ContentVersion where ContentDocumentId='" +
            docId +
            "'",
          false
        );
        if (doccontent != null) {
          let doc64data = await QueryData(doccontent[0].VersionData, true);
          if (doc64data.data != null) {
            let newccIds = [];
            await Word.run(async (context) => {
              // Use the Base64-encoded string representation of the selected .docx file.
              const externalDoc = context.application.createDocument(doc64data.data);
              await context.sync();

              let maincusXML = "";
              const cusparts = externalDoc.customXmlParts;
              cusparts.load("items");
              await context.sync();
              let cusxmlarray = [];
              for (var k = 0; k < cusparts.items.length; k++) {
                cusxmlarray.push(cusparts.items[k].getXml());
              }
              await context.sync();
              for (k = 0; k < cusxmlarray.length; k++) {
                if (cusxmlarray[k].value.indexOf("sffields") > 0) {
                  maincusXML = cusxmlarray[k].value;
                  break;
                }
              }

              let contentctrls = externalDoc.contentControls;
              contentctrls.load("items");
              await context.sync();

              for (var i = 0; i < contentctrls.items.length; i++) {
                contentctrls.items[i].load(
                  "appearance," +
                    "cannotDelete," +
                    "cannotEdit," +
                    "color," +
                    "id," +
                    "placeHolderText," +
                    "removeWhenEdited," +
                    "title," +
                    "text," +
                    "type," +
                    "style," +
                    "tag," +
                    "font/size," +
                    "font/name," +
                    "font/color," +
                    "parentContentControlOrNullObject"
                );
                let strId = contentctrls.items[i].id;
                newccIds.push(getCusxmlFromConID(maincusXML, strId));
                console.log("ID: " + strId);
              }
            });
            console.log(newccIds);
            await Word.run(async function (context) {
              var selection = context.document.getSelection();
              var selInsertRng = selection.insertFileFromBase64(doc64data.data, "Replace");
              await context.sync();
              let contentctrls = selInsertRng.contentControls;
              contentctrls.load("items");
              await context.sync();
              for (var i = 0; i < contentctrls.items.length; i++) {
                contentctrls.items[i].load(
                  "appearance," +
                    "cannotDelete," +
                    "cannotEdit," +
                    "color," +
                    "id," +
                    "placeHolderText," +
                    "removeWhenEdited," +
                    "title," +
                    "text," +
                    "type," +
                    "style," +
                    "tag," +
                    "font/size," +
                    "font/name," +
                    "font/color," +
                    "parentContentControlOrNullObject"
                );
                let strId = contentctrls.items[i].id;
                console.log("New ID: " + strId);
                newccIds[i] = newccIds[i].replace("NEWIDINS", strId);
              }
              console.log(newccIds);
              for (i = 0; i < newccIds.length; i++) {
                await addCustomXmlPart(newccIds[i]);
              }
            }).catch(function (myError) {
              console.log(myError.message);
            });
          }
        }
      }
      setprogress(false);
    }
  }

  function getCusxmlFromConID(mainXML, strid) {
    var matched = "";
    if (window.DOMParser) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(mainXML, "text/xml");
      if (doc.getElementById(strid) != null) {
        console.log("XML Matched");
        matched = doc.getElementById(strid).outerHTML;
        matched = matched.replace('"' + strid + '"', "'NEWIDINS'");
      }
    }
    return matched;
  }

  const QueryData = async (soqlquery: string, childrelation: boolean) => {
    try {
      setprogress(true);
      const res = await axiosBaseURL
        .get("/sfserver/query?q=" + soqlquery, {
          withCredentials: true,
        })
        .catch((error) => {
          setprogress(false);
          if (error.response) {
            seterrMsgd(error.response.data);
          } else if (error.request) {
            seterrMsgd(error.request);
          } else {
            seterrMsgd(error.message);
          }
        });
      setprogress(false);
      console.log(res.data);
      if (res.data != null) {
        if (!childrelation) return res.data.records;
        else if (childrelation) return res.data;
      } else return null;
    } catch (err) {
      setprogress(false);
    }
  };

  async function GetTemplateObject() {
    setprogress(true);
    let result = await QueryData("SELECT Id, Name, Description__c, Type__c FROM Template__c", false);
    setprogress(false);
    if (result != null) {
      let arrrefs = [];
      result.forEach((record) => {
        arrrefs.push({
          id: record.Id,
          name: record.Name,
          description: record.Description__c,
          type: record.Type__c,
        });
      });
      arrrefs.sort((a, b) => a.name.localeCompare(b.name));
      settemplatedata(arrrefs);
      setorglistvalues(arrrefs);
      setSelectedIndex(-1);
    }
  }

  useEffect(() => {
    GetTemplateObject().then(() => {
      fetchData();
    });
  }, []);

  useEffect(() => {
    if (searchValue.length === 0) {
      if (seltype === "All") {
        settemplatedata(orglistvalues);
      } else {
        let filterlst = orglistvalues.filter(function (obj) {
          return obj.type === seltype;
        });
        settemplatedata(filterlst);
      }
    } else {
      const newlistvalues = templatedata.filter((value) =>
        value.name.toLowerCase().includes(searchValue.toLowerCase())
      );
      settemplatedata(newlistvalues);
    }
  }, [searchValue]);

  return (
    <Box sx={{ p: 1, marginTop: 0, marginLeft: 0, marginRight: 0 }}>
      {errMsgd.length > 0 ? <OfficeAddinMessageBar onDismiss={errorDismissed} message={errMsgd + " "} /> : null}
      <Grid container>
        <Grid item xs={12} sx={{ marginTop: 1 }}>
          <FormControl fullWidth>
            <InputLabel id="typelabel">Filter by type</InputLabel>
            <Select
              size="small"
              sx={{ padding: 0 }}
              labelId="typelabel"
              defaultValue="All"
              name="type"
              label="Filter by type"
              value={seltype}
              onChange={handleSelectChange}
            >
              <MenuItem key="All" value="All">
                All
              </MenuItem>
              {typelist.map((picklst) => (
                <MenuItem key={picklst.label} value={picklst.value}>
                  {picklst.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sx={{ marginTop: 1 }}>
          <FormControl fullWidth size="small" sx={{ minWidth: 260, padding: 0 }}>
            <TextField
              name="searchfield"
              label="Search template"
              size="small"
              variant="outlined"
              onChange={(e) => setSearchValue(e.target.value)}
              value={searchValue}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sx={{ marginTop: 1 }}>
          <Box>
            <Paper elevation={0} sx={{ border: 1, borderColor: "lightgray", overflow: "auto" }}>
              <List dense disablePadding sx={{ padding: 0 }}>
                {_DATA.currentData().map((item, index) => (
                  <ListItemButton
                    key={index}
                    selected={selectedIndex === index}
                    onClick={() => {
                      setSelectedIndex(index);
                    }}
                    sx={{ padding: 0, pl: 2 }}
                  >
                    <Grid container>
                      <Grid item xs={8}>
                        <ListItemText
                          primary={<Typography sx={{ fontSize: "15px" }}>{item.name}</Typography>}
                          sx={{ marginLeft: 1 }}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <Stack direction="column">
                          <ListItemText
                            primary={<Typography sx={{ fontSize: "12px" }}>{item.type}</Typography>}
                            sx={{ marginLeft: 0, fontStyle: "italic", color: "#1C39BB" }}
                          />
                          <Chip
                            onClick={() => OpenSelectedTemplate()}
                            label="Insert"
                            variant="filled"
                            sx={
                              selectedIndex === index
                                ? {
                                    height: "22px",
                                    display: "block",
                                    marginTop: 0,
                                    bgcolor: "#1C39BB",
                                    width: 56,
                                    color: "white",
                                  }
                                : { height: "22px", display: "none" }
                            }
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  </ListItemButton>
                ))}
              </List>
            </Paper>
          </Box>
        </Grid>
        <Grid item>
          <AppBar position="fixed" sx={{ top: "auto", bottom: 0, bgcolor: "white" }}>
            <Stack direction="row" justifyContent="flex-end">
              <Typography sx={{ fontSize: 14, marginTop: 0.5, color: "#1C39BB" }}>Page: {page}</Typography>
              <Pagination count={count} page={page} onChange={handleChange} />
            </Stack>
          </AppBar>
        </Grid>
      </Grid>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isprogress}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default Playbook;
